import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo-white.svg';
import _imports_1 from '@/assets/logo-rostrud.svg';
import _imports_2 from '@/assets/logo-pifia.svg';
const _hoisted_1 = {
  class: "header-component"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-wrap\"><div class=\"logo-part\"><a target=\"_blank\" href=\"https://www.hse.ru/\"><img alt=\"ВШЭ Логотип\" src=\"" + _imports_0 + "\" height=\"100%\"></a></div><div class=\"sep\"></div><div class=\"logo-part\"><img alt=\"ВШЭ Логотип роструд\" src=\"" + _imports_1 + "\" height=\"100%\"></div><div class=\"sep\"></div><div class=\"logo-part\"><img alt=\"ВШЭ Логотип пифия\" src=\"" + _imports_2 + "\" height=\"100%\"></div></div><h1 class=\"fz40 mt-60 mb-12\">Пифия</h1><div class=\"sub-header\" style=\"max-width:550px;\"> ИИ-помощник выбора <br> образовательной траектории </div><div class=\"sub-sub-header\" style=\"max-width:550px;\"> Поможем определить вашу потенциальную зарплату после выпуска из университета. </div>", 4);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_router_link, {
    to: "/methodology"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      round: "",
      class: "mt-24 mb-70",
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode("Как работает ИИ-помощник? ")]),
      _: 1
    })]),
    _: 1
  })])]);
}